import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const stockListTodo = createAsyncThunk("stockList", async ({ pageable: data, navigate }) => {
  try {
    const res = await axios({
      method: "GET",
      url: process.env.REACT_APP_API_URL + `grn/store_details`,
      params: {
        pageSize: data?.pageSize,
        pageNo: data?.currentPage,
        search: data?.search,
        grn_id: data?.grn_id,
        type: ['item', 'machine'],
      },
      paramsSerializer: { indexes: null },
      headers: { "Content-Type": "application/json", Authorization: SessionManager.getSession("user_token"), },
    });
    return res;
  } catch (error) {
    return error.response;
  }
}
);

export const addStoreDetailsTodo = createAsyncThunk("addStoreDetails", async ({ values, navigate }) => {
  try {
    const res = await axios({
      method: "POST",
      url: process.env.REACT_APP_API_URL + `grn/store_details`,
      data: {
        grn_id: values?.grn_id,
        lines: values?.lines,
      },
      headers: { "Content-Type": "application/json", Authorization: SessionManager.getSession("user_token"), },
    });
    return res;
  } catch (error) {
    return error.response;
  }
}
);

const stockListSlice = createSlice({
  name: "stockList",
  initialState: {
    data: [],
  },
  extraReducers: (builder) => {
    builder.addCase(stockListTodo.fulfilled, (state, action) => {
      if (action?.payload?.status === 200) {
        state.data = action.payload.data.data;
      } else if (action?.payload?.status === 401) {
        showTokenExpiredAlert(
          action?.payload?.data?.message,
          action.meta.arg.navigate
        );
      } else if (action?.payload?.status === 403) {
        showAccessDeniedAlert(action.meta.arg.navigate);
      } else {
        state.data = [];
      }
    });
    builder.addCase(stockListTodo.rejected, () => {
      // silent reject
    });
  },
});

export default stockListSlice.reducer;
